module.exports = __webpack_public_path__ + "img/tabIcMemberOff.670c6ace.svg";